import { getAuthHeaders } from './authService';

const base = `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/ops/cloud-read`;

export async function cloudRead(operation, params = {}, signal) {
  const query = new URLSearchParams(params);
  const response = await fetch(`${base}/${operation}${query.size ? `?${query}` : ''}`, {
    headers: getAuthHeaders(), signal,
  });
  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`Respuesta cloud no válida (HTTP ${response.status}).`);
  }
  if (!response.ok) throw new Error(data.detail || data.message || `Error cloud HTTP ${response.status}.`);
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Formato cloud no válido.');
  return data;
}

export function saveCloudCsv(csv, filename) {
  const url = URL.createObjectURL(new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
